import { hexToRgb, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const customTagStyle = (theme) => ({
	root: ({ color }) => ({
		border: `1px solid ${color || primaryColor[0]}`,
		borderRadius: 16,
		padding: '2px 8px',
		display: 'flex',
		alignItems: 'center',
		marginRight: 4,
		marginBottom: 2,
		cursor: 'pointer',
		transition: 'all 0.3s ease-in-out',
		'& svg': {
			fontSize: '1rem',
			color: color || primaryColor[0],
		},
		'&:hover': {
			backgroundColor: `rgba( ${hexToRgb(color || primaryColor[0])}, 0.15)`,
		},
	}),
	clearAll: {
		border: 'none',
		backgroundColor: `rgba( ${hexToRgb(primaryColor[0])}, 0.15)`,
		'&:hover': {
			backgroundColor: `rgba( ${hexToRgb(primaryColor[0])}, 0.50)`,
		},
	},
	label: ({ color }) => ({
		margin: 0,
		marginRight: 4,
		fontSize: theme.fontSize(14),
		color: color || primaryColor[0],
		lineHeight: 1.43,
	}),
});

export default customTagStyle;
